(function () {
  /**
   * 募集ブロック0件のパネルだけ（.js-recruit-jobs には触れない）
   * ※タブ付きパネルは recruit-jobs.js がタブ単位の空表示を担当する
   *
   * 採用ページでは recruit-page と recruit-jobs を兄弟の shopify-section のままにし、
   * 一方を他方の中へ DOM 移動しない（管理画面の HTML チェックで不正扱いになるため）。
   */
  function syncRecruitEmptyState(panel) {
    if (!panel || !panel.querySelector) return;
    var list = panel.querySelector('.recruit-jobs__list');
    var itemCount = list ? panel.querySelectorAll('.recruit-jobs__item').length : 0;
    var msg = panel.querySelector('[data-recruit-empty-message]');
    var tabs = panel.querySelector('.recruit-jobs__tabs-bleed');
    var stack = panel.querySelector('.recruit-jobs__stack');
    var hasBelow = panel.getAttribute('data-recruit-below') === 'true';
    if (itemCount === 0) {
      panel.classList.add('recruit-jobs--empty');
      if (stack && !hasBelow) stack.classList.add('recruit-jobs__stack--empty');
      if (stack && hasBelow) stack.classList.remove('recruit-jobs__stack--empty');
      if (msg && !hasBelow) msg.removeAttribute('hidden');
      if (msg && hasBelow) msg.setAttribute('hidden', '');
      if (tabs) tabs.setAttribute('hidden', '');
    } else {
      panel.classList.remove('recruit-jobs--empty');
      if (stack) stack.classList.remove('recruit-jobs__stack--empty');
      if (msg) msg.setAttribute('hidden', '');
      if (tabs) tabs.removeAttribute('hidden');
    }
  }

  document.querySelectorAll('.recruit-jobs:not(.js-recruit-jobs)').forEach(syncRecruitEmptyState);
})();
